// models/FavoritesDTO.js

export class FavoriteItem {
  constructor(data = {}) {
    this.name = data.name || '';
    this.displayOrder = data.displayOrder || 0;
  }
}

export class FavoritesRequestDTO {
  constructor(favorites = []) {
    this.favorites = favorites.map((fav, index) => ({
      name: fav.name || fav,
      displayOrder: typeof fav.displayOrder !== 'undefined' ? fav.displayOrder : index
    }));
  }
}

export class FavoriteResponseItem {
  constructor(data = {}) {
    this.id = data.id;
    this.userId = data.userId;
    this.reportTypeId = data.reportTypeId;
    this.displayOrder = data.displayOrder || 0;
    this.createdAt = data.createdAt;
  }
}

export class FavoritesResponseDTO {
  constructor(data = {}) {
    this.success = data.success || false;
    this.data = {
      favorites: (data.data?.favorites || []).map(fav => new FavoriteResponseItem(fav))
    };
    this.message = data.message || '';
  }

  getFavorites() {
    return this.data.favorites;
  }
}

export default FavoritesRequestDTO;